import { render, staticRenderFns } from "./template.vue?vue&type=template&id=cb1a7d44&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=cb1a7d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1a7d44",
  null
  
)

export default component.exports